// lib
import { batch } from "react-redux";
import { pick, omit } from "ramda";
// src
import { STORAGE_VERSION } from "config/constants";
import { setThrottledTimout } from "utils/timeout";
import { computeDisplay } from "actions/events/thunks";
import { hydrateSlice, hydrateSuccess } from "actions/system";

const SAVE_THROTTLE_DELAY = 500;

// Private
const set = (key, state, saveDelay = SAVE_THROTTLE_DELAY) => {
  setThrottledTimout(
    () => {
      localStorage.setItem(key, JSON.stringify(state));
    },
    saveDelay,
    `storage/${key}`,
  );
  return state;
};

const get = (key) => JSON.parse(localStorage.getItem(key));

const fullKey = (key) => `${STORAGE_VERSION}.${key}`;

// API
export const hydrate = (dispatch) => {
  Object.keys(localStorage).forEach((key) => {
    const version = key.split(".")[0];
    if (version !== STORAGE_VERSION) {
      localStorage.removeItem(key);
    } else {
      const fullState = get(key);
      if (fullState) {
        const { maxAge, savedAt, ...state } = fullState;
        const expired = maxAge && Date.now() - savedAt > maxAge;
        if (!expired) dispatch(hydrateSlice({ key, state }));
      }
    }
  });
  batch(() => {
    dispatch(hydrateSuccess());
    dispatch(computeDisplay());
  });
};

export const clearStorage = () => localStorage.clear();

export const clearSlice = (key) => localStorage.removeItem(fullKey(key));

export const buildStorageAdapters = (key, { maxAge, blacklist, whitelist, saveDelay }) => {
  const FULL_KEY = fullKey(key);
  const hydrateAdapter = (state, { key: actionKey, state: actionState }) => {
    if (actionKey === FULL_KEY) return { ...state, ...actionState };
    return state;
  };
  const saveAdapter = (state) => {
    let toStore = state;
    // maxAge always stored
    if (whitelist) toStore = pick(whitelist, toStore);
    if (blacklist) toStore = omit(blacklist, toStore);
    if (maxAge) toStore = { ...toStore, maxAge, savedAt: Date.now() };
    set(FULL_KEY, toStore, saveDelay);
    return state;
  };
  return [hydrateAdapter, saveAdapter];
};
